import React from 'react';
import { BiSupport } from 'react-icons/bi';
import { FaCar, FaHotel } from 'react-icons/fa6';
import { ImTruck } from 'react-icons/im';
import { IoMdBoat } from 'react-icons/io';
import { MdOutlineSecurity } from 'react-icons/md';

const HomeService = () => {
    const services = [
        { _id: 1, icons: <FaCar size={60} />, title: "Véhicules", description: `Des véhicules récents, bien entretenus et accessibles en quelques clics à des prix compétitifs. ` },
        { _id: 1, icons: <FaHotel size={60} />, title: "Propriétés", description: `Des propriétés vérifiées, faciles à réserver, pour tous les besoins et tous les budgets. ` },
        // { _id: 1, icons: <IoMdBoat size={60} />, title: "Location de bateaux", description: `Vous pouvez demander à votre compagnon de voyage de vous accompagner et de vous guider tout au long de votre voyage.` },
        // { _id: 1, icons: <ImTruck size={60} />, title: "Location de remorques", description: `We guarantee the safety of the engine on the car always running well with regular checks on the car engine.` },
        // { _id: 1, icons: <MdOutlineSecurity size={60} />, title: "Sécurité et assurance", description: `Notre garantie de service offre une possibilité de remboursement si la voiture ne correspond pas aux informations fournies.` },
        // { _id: 1, icons: <BiSupport size={60} />, title: "Assistance 24/7", description: `Our service provides direct customer monitoring to monitor trips in terms of safety and comfort.` },
    ]

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1200 },
            items: 4,
        },
        desktop: {
            breakpoint: { max: 1200, min: 992 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1,
        },
    };


    return (
        <div className="container-fluid" style={{ padding: "100px 0px 100px 0px" }}>
            <div className="container-fluid" style={{ display: "flex", flexDirection: "column", justifyContent: "center", }}>
                <div><h5 style={{ color: "#43B613", textAlign: "center" }}>AVANTAGES</h5></div>
                <div><h2 style={{ color: "#737373", textAlign: "center" }}>Pourquoi nous choisir ? </h2></div>
                <div>
                    <p style={{ color: "#A6A6A6", textAlign: "center" }}>
                        Nous vous offrons de nombreuses garanties et avantages lorsque vous louez une voiture avec nous pour votre voyage.<br />
                        Voici quelques-uns des avantages que vous obtiendrez
                    </p>
                </div>
            </div>

            {/*listes de vehoicule */}
            <div className="container-fluid" style={{ padding: "50px 10px 50px 10px" }}>

                <div className="row" style={{ justifyContent: "center" }} >
                    {
                        services.map((item) => {
                            return (
                                <div className="col-md-3 rounded-lg" style={{ margin: "10px", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignContent: "center" }}>
                                    <div>
                                        {item.icons}
                                    </div>
                                    <div style={{ padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                                        <div><h6 style={{ color: "#737373" }}>{item.title}</h6></div>
                                        <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                            <div>
                                                <p style={{ color: "#A6A6A6" }}>{item.description || ""}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>


        </div>
    );
};

export default HomeService;
